module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "id": "results-nav"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": '/'
    }
  }, [_vm._v("Protocol Library")])], 1), _vm._v(" "), (_vm.category) ? _c('li', [_c('router-link', {
    attrs: {
      "to": ("/categories/" + (_vm.scrub(_vm.category)))
    }
  }, [_vm._v("\n            " + _vm._s(_vm.category) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.subcategory) ? _c('li', [_c('router-link', {
    attrs: {
      "to": ("/categories/" + (_vm.scrub(_vm.category)) + "/" + (_vm.scrub(_vm.subcategory)))
    }
  }, [_vm._v("\n            " + _vm._s(_vm.subcategory) + "\n          ")])], 1) : _vm._e()])]), _vm._v(" "), _c('main', {
    attrs: {
      "id": "category"
    }
  }, [_c('aside', {
    staticClass: "refine"
  }, [_c('h2', {
    on: {
      "click": function($event) {
        _vm.home()
      }
    }
  }, [_vm._v("Protocol Library")]), _vm._v(" "), _c('Categories'), _vm._v(" "), _c('CalloutDocs')], 1), _vm._v(" "), _c('section', {
    staticClass: "results"
  }, [_c('div', {
    staticClass: "selected-category"
  }, [_c('h4', [_vm._v("Results For:\n        "), _vm._l((_vm.queryOriginator()), function(value, key) {
    return (value != null) ? _c('span', {
      staticClass: "query"
    }, [_vm._v("\n        \"" + _vm._s(value) + "\" \n        ")]) : _vm._e()
  })], 2), _vm._v(" "), _vm._l((_vm.protocols), function(protocol) {
    return _c('ProtocolPreview', {
      attrs: {
        "protocol": protocol
      }
    })
  }), _vm._v(" "), (_vm.protocols.length === 0) ? _c('span', [_vm._v("\n           Don't see the protocol you need? We'll make it for you! Schedule a demo or chat with our Science team "), _c('a', {
    attrs: {
      "id": "intercom-chat",
      "href": "#",
      "onclick": "window.Intercom('show');",
      "data-gtm-action": "click",
      "data-gtm-category": "Intercom",
      "data-gtm-label": "click"
    }
  }, [_vm._v("here")]), _vm._v(".\n           ")]) : _vm._e()], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-693afa2e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResultsView.vue
// module id = 160
// module chunks = 2